import React from 'react';
import { formatScore } from './scoring';

// Both scores on one 0–10 rule, with the stretch between them inked in. The
// distance between the dots is the disagreement — you read it before you read
// either number.
const position = (score) => `${(Number(score) / 10) * 100}%`;

const gapWording = (gap) => {
  if (gap === 0) return 'exactly the same';
  return `${formatScore(gap)} apart`;
};

const ScoreLine = ({ mine, theirs, me, them, gap }) => {
  const low = Math.min(Number(mine.score), Number(theirs.score));
  const high = Math.max(Number(mine.score), Number(theirs.score));

  return (
    <div className="helen-scoreline">
      <div className="helen-rule" aria-hidden="true">
        <span
          className="helen-rule-span"
          style={{ left: position(low), width: `${((high - low) / 10) * 100}%` }}
        />
        <span className="helen-dot is-mine" style={{ left: position(mine.score) }} />
        <span className="helen-dot is-theirs" style={{ left: position(theirs.score) }} />
      </div>

      <div className="helen-reads">
        <span className="helen-read">
          <span className="helen-read-who">{me?.initial}</span>
          <span className="helen-read-score">{formatScore(mine.score)}</span>
        </span>
        <span className="helen-gap">{gapWording(gap)}</span>
        <span className="helen-read is-theirs">
          <span className="helen-read-score">{formatScore(theirs.score)}</span>
          <span className="helen-read-who">{them?.initial}</span>
        </span>
      </div>
    </div>
  );
};

export default ScoreLine;
